'use strict'

const isIscoUri = (uri) => String(uri || '').includes('/esco/isco/')

const catalogSuggestion = (row) => {
  if (row == null || typeof row !== 'object') {
    return { label: row == null ? '' : String(row), conceptType: '', uri: '' }
  }
  const uri = row.uri ? String(row.uri) : ''
  const conceptType = isIscoUri(uri) ? 'occupation' : (row.conceptType || '')
  return {
    label: row.label == null ? '' : String(row.label),
    conceptType,
    uri
  }
}

const catalogSuggestions = (result) => (
  Array.isArray(result) ? result.map(catalogSuggestion) : []
)

const iscoOccupationBadge = (item) => {
  if (!item || typeof item !== 'object' || !isIscoUri(item.uri)) return ''
  return 'OCCUPATION'
}

/** Browser language (en|es|…) with English fallback. */
const browserLang = () => {
  let raw = ''
  if (typeof navigator !== 'undefined') {
    if (Array.isArray(navigator.languages) && navigator.languages.length) {
      raw = navigator.languages[0]
    } else {
      raw = navigator.language || navigator.userLanguage || ''
    }
  }
  const code = String(raw).trim().toLowerCase().split(',')[0].split(';')[0].split('-')[0].split('_')[0]
  return /^[a-z]{2,3}$/.test(code) ? code : 'en'
}

/** Current UI language from the browser (fallback en). */
const uiLang = () => browserLang()

/**
 * Fetch init for ESCO autocomplete endpoints.
 * Sends UI lang as body.lang and Accept-Language (same URI, localized label).
 */
const escoAutocompleteFetchInit = (vm, body) => {
  const lang = uiLang(vm)
  const payload = Object.assign({}, body || {}, { lang })
  return {
    method: 'POST',
    body: JSON.stringify(payload),
    headers: {
      'Content-Type': 'application/json',
      'Auth-Token': vm.$cookie.get('jwt_token'),
      'Accept-Language': lang
    }
  }
}

module.exports = {
  isIscoUri,
  catalogSuggestion,
  catalogSuggestions,
  iscoOccupationBadge,
  uiLang,
  browserLang,
  escoAutocompleteFetchInit
}
